var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline ml-2"},[(_vm.valid)?_c('span',{staticClass:"d-inline text-success"},[_c('strong',[_vm._v("HTTPS")]),_c('i',{staticClass:"icon-checkmark"})]):_c('span',{staticClass:"d-inline text-danger"},[_c('strong',[_vm._v("HTTPS")]),_c('i',{staticClass:"icon-close"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }